import React, { use, useEffect, useState } from 'react';
import TextInput from '../Common/TextInput';
import { useVendor } from '../../DataStore/VendorContext';

const VendorSelector = ({ value, onChange, wrap = false, placeholder = "Type and Select....", label ="Payee", showCreate=true }) => {
  const { setSearchHint, payeeSearchList, vendorListing, getVendorListing  } = useVendor();
  const [options, setOptions] = useState( showCreate? [{ label: 'Create new vendor...', value: 'add' }] : []);

  // useEffect(() => {
  //   if (Array.isArray(payeeSearchList)) {
  //     const list = showCreate ? [{ label: 'Create new vendor...', value: 'add' }] : [];
  //     payeeSearchList.forEach((item) =>
  //       list.push({ label: item.title, value: item.payee_id })
  //     );

  //     setOptions(list);
  //   }
  // }, [payeeSearchList]);

  useEffect(() => {
    getVendorListing();
  }, []);

  useEffect(() => {
    if (Array.isArray(vendorListing)) {
      const list = showCreate ? [{ label: 'Create new vendor...', value: 'add' }] : [];
      vendorListing.forEach((item) =>
        list.push({ label: item.title, value: item.payee_id })
      );

      setOptions(list);
    }
  }, [vendorListing]);


  const handleType = (e) => {
    const inputValue = e.key;
    // console.log('Input value', inputValue)
    if (setSearchHint && typeof setSearchHint === 'function') {
      setSearchHint(inputValue); // Set the search hint for vendor filtering
    }
  };

  return (
    <TextInput
      label={label}
      type="select"
      leftIcon="fa fa-truck"
      placeholder={placeholder}
      options={options}
      onChange={(item) => onChange(item)}
      leftComponent={<i className="fa fa-truck link"></i>}
      loading={false}
      wrap={wrap}
      onType={handleType}
      value={value}
    />
  );
};

export default VendorSelector;
